import React from 'react'
import VipIcon from '../../../form/component/VipIcon'
import Table from '../../../form/component/Table'
import { renderProcessName } from '../../../process/util/names'

export default [
    {
        property: 'vip',
        header: 'VIP',
        width: '45',
        renderer: (processInstance) => {
            return <VipIcon active={processInstance.vip}/>
        },
    },
    {
        property: 'started',
        header: 'Started',
        comparator: Table.dateComparator('started'),
        renderer: Table.dateTimeRenderer('started'),
    },
    {
        property: 'lastStatusChange',
        header: 'Last Status Change',
        comparator: Table.dateComparator('lastStatusChange'),
        renderer: Table.dateTimeRenderer('lastStatusChange'),
    },
    {
        property: 'processName',
        header: 'process Name',
        renderer: (processInstance) => {
            return renderProcessName(processInstance.processName)
        },
        sortValue: (processInstance) => {
            return renderProcessName(processInstance.processName)
        },
    },
    {
        property: 'displayName',
        header: 'display Name',
    },
]



// WEBPACK FOOTER //
// ./src/modules/analytics/component/state-responsible/process-instance-column-list.js